module.exports = __webpack_public_path__ + "img/glasses-8-1.7a2e331c.svg";